import { SerializedStyles } from "@emotion/react";
import { Ref, memo, useCallback } from "react";
import { BooleanRadioOptions, FormFlowPage } from "src/components";
import { createStyles } from "src/styles";

import { usePartialSubmit } from "../hooks";

export interface ExistingLoansProps {
  value?: boolean;
  onChange: (value: boolean) => void;

  focusRef?: Ref<HTMLDivElement>;
  onNext: () => void;
  onBack: () => void;
  style?: SerializedStyles;
}

const styles = createStyles({
  options: {
    marginBottom: 30,
  },
});

const ExistingLoans = ({
  value,
  onChange,
  onNext,
  onBack,
  style,
  focusRef,
  ...props
}: ExistingLoansProps) => {
  const validate = useCallback(() => value !== undefined, [value]);
  const { handleNext, nextDisabled, nextLoading } = usePartialSubmit({ onNext, validate });

  return (
    <FormFlowPage
      {...props}
      ref={focusRef}
      title="Do you have an existing home loan or mortgage?"
      description="This helps us determine if you have enough equity to qualify."
      onNext={handleNext}
      onBack={onBack}
      style={style}
      nextDisabled={nextDisabled}
      nextLoading={nextLoading}
    >
      <BooleanRadioOptions style={styles.options} onChange={onChange} value={value} />
    </FormFlowPage>
  );
};

export default memo(ExistingLoans);
